module.exports = __webpack_public_path__ + "static/media/delivery.c9fe456e.png";